import { Suspense, lazy } from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";

import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "./App.css";
import "./index.css";

import Main from "./page/index";
import AuthCallback from "./page/AuthCallBack/AuthCallBack";

// A/B test: variant B is lazy-loaded so it never lands in variant A's bundle.
const MainTesteB = lazy(() => import("./page/teste-b"));

function App() {
  return (
    <div className="App">
      <Router basename={process.env.PUBLIC_URL}>
        <Routes>
          <Route path="/" element={<Main />} />
          <Route
            path="/b"
            element={
              <Suspense
                fallback={<div className="text-center p-8">Carregando...</div>}
              >
                <MainTesteB />
              </Suspense>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
